import type { Component } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Form from '~/components/Form'
import Input from '~/components/Input'
import Select from '~/components/Select'
import Switch from '~/components/Switch'
import type { TabComercialProps } from './types'

const TabComercial: Component<TabComercialProps> = props => {
  return (
    <>
      <Card>
        <Card.Header>Información comercial</Card.Header>
        <Card.Body>
          <Form id="comercial-form" onSubmit={props.handleSaveComercial} initialValues={props.initialValues(props.data)}>
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
              <Input name="cupoCredito" label="Cupo de crédito" type="number" />
              <Input name="diasCredito" label="Días de crédito" type="number" />
              <Input name="descuentoPorDefecto" label="Descuento por defecto (%)" type="number" />
              <Select name="moneda" label="Moneda" options={props.monedaOptions()} value={props.data.moneda ?? 'COP'} />
              <Input name="correoFacturacion" label="Correo de facturación" type="email" />
              <Input name="origenCliente" label="Origen del cliente" placeholder="Web, referido, catálogo..." />
              <Select name="clasificacion" label="Clasificación" options={props.clasificacionOptions()} value={props.data.clasificacion ?? ''} clearable />
              <Select name="estadoCliente" label="Estado del cliente" options={props.estadoClienteOptions()} value={props.data.estadoCliente ?? 'prospecto'} />
              <Input name="calificacion" label="Calificación (1-5)" type="number" min="1" max="5" />
              <Switch name="aceptaCredito" label="Acepta crédito" class="lg:col-span-2" />
            </div>
          </Form>
        </Card.Body>
      </Card>
      <div class="flex justify-end mt-4">
        <Button type="submit" form="comercial-form" disabled={props.isSaving()}>
          Guardar
        </Button>
      </div>
    </>
  )
}

export default TabComercial
